export interface PlatformStatistics {
  reservations_count: number;
  students_count: number;
  teachers_count: number;
  courses_count: number;
}

export const getNumberValue = (value: number): string => {
  const roundedValue = Math.round(value / 50) * 50;

  if (value < 2000) {
    return '' + roundedValue;
  }

  const reducedNumber = Math.floor(roundedValue / 1000);

  return `${reducedNumber}mil`;
};

export const getPlatformStatistics = async (
  fromDate: string
): Promise<PlatformStatistics | undefined> => {
  const statisticsUrl = `${process.env.REACT_APP_ESTUDI_API_URL}/estudi/web/statistics?from=${fromDate}`;

  try {
    const response = await fetch(statisticsUrl);

    if (!response.ok) {
      throw new Error(`GET ${statisticsUrl} respondió ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(error);
  }

  return undefined;
};
